import { FREE_PLAN_BAR_CLICK_ON_PROCCED } from '@constants/mixpanel'
import { defaultFreePlan, defaultLitePlan, PLAN_NAMES } from '@constants/plans'
import { useUserContext } from '@contexts/user'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { formatNumericBasedOnLanguage } from '@helpers/data'
import Diamond from '@images/diamond.png'
import { Features } from '@pages/Checkout/routes/Plans/components/PlanPanels/components/Plan/components/Features'
import { Limits } from '@pages/Checkout/routes/Plans/components/PlanPanels/components/Plan/components/Limits'
import { MODAL_SUMMARY_SUBSCRIPTION } from '@pages/Pricing/routes/AccountPackage/components/PlanPanels/components/SummarySubscriptionModal'
import { mixpanelEvent } from '@services/mixpanel'
import { useGetPackages } from '@services/payments/useGetPackages'
import {
  Badge,
  Button,
  Heading,
  Image,
  Loader,
  Modal,
  ModalBody,
  ModalHeader,
  Paragraph,
  Price,
  Spacer,
  Spreader
} from '@ui-kit'
import { Trans, useTranslation } from 'react-i18next'
import { Column, Row } from 'simple-flexbox'

import { getMonthlyLitePlanPrice } from './helpers/getMonthlyLitePlanPrice'
import styles from './UpgradeToLiteModal.module.scss'

export const UpgradeToLiteModal = NiceModal.create(() => {
  const { t } = useTranslation()

  const { remove } = useModal()

  const { accountCurrency } = useUserContext()

  const { data: packages, isLoading: packagesIsLoading } = useGetPackages()

  const price = getMonthlyLitePlanPrice({
    packages: packages ?? [],
    accountCurrency
  })

  const handleOpenModal = () => {
    mixpanelEvent({
      name: FREE_PLAN_BAR_CLICK_ON_PROCCED
    })

    NiceModal.show(MODAL_SUMMARY_SUBSCRIPTION)

    remove()
  }

  return (
    <Modal size={850} onClose={remove}>
      <ModalHeader />

      {packagesIsLoading ? (
        <Loader />
      ) : (
        <ModalBody className={styles['upgrade-to-lite-modal__body']}>
          <div className={styles['upgrade-to-lite-modal__row']}>
            <Column
              vertical='space-between'
              className={styles['upgrade-to-lite-modal__col-lite']}
            >
              <Row alignItems='center'>
                <Image src={Diamond} width='26px' height='26px' />

                <Spreader spread={10} />

                <Heading level={2} weight={600}>
                  <Trans
                    i18nKey='upgrade.to.plan'
                    values={{ plan: PLAN_NAMES.LITE }}
                  />
                </Heading>
              </Row>

              <Spacer space={10} />

              <Price amount={price} currency={accountCurrency}>
                {t('addons.store.month')}
              </Price>

              <Spacer space={10} />

              <Limits recordKey={defaultLitePlan} />

              <Spacer space={5} />

              <Paragraph size={16}>
                <Trans i18nKey='compare.plans.description.limits.unlimited.conversion' />
              </Paragraph>

              <Spacer space={15} />

              <Features recordKey={defaultLitePlan} />

              <Spacer space={20} />

              <div>
                <Button onClick={handleOpenModal}>Procced Upgrade</Button>
              </div>
            </Column>

            <Column
              vertical='space-between'
              className={styles['upgrade-to-lite-modal__col-free']}
            >
              <div>
                <Row vertical='center'>
                  <Heading level={2} weight={600}>
                    FREE
                  </Heading>

                  <Spreader spread={10} />

                  <Badge variant='neutral1-filled'>
                    {t('addons.store.current.plan')}
                  </Badge>
                </Row>

                <Spacer space={10} />

                <Price amount={0} currency={accountCurrency}>
                  {t('addons.store.month')}
                </Price>

                <Spacer space={10} />

                <Limits recordKey={defaultFreePlan} />

                <Spacer space={5} />

                <Paragraph size={16}>
                  <Trans
                    i18nKey='checkout.plans.plan.limits.conversions'
                    values={{ count: formatNumericBasedOnLanguage(100) }}
                  />
                </Paragraph>
              </div>
            </Column>
          </div>
        </ModalBody>
      )}
    </Modal>
  )
})

UpgradeToLiteModal.displayName = 'TopbarInfobarFreePlansUpgradeToLiteModal'
